export default __webpack_public_path__ + "media/images/15-8845167d224950251f857dc054898201.jpg";